export const getUserAgentMatch = (userAgents: string) => {
  const userAgent = navigator.userAgent;
  const userAgentsRegex = new RegExp(userAgents, 'i');
  return userAgentsRegex.test(userAgent);
};
